import m from "../../geodata/es2015/switzerlandHigh";
window.am4geodata_switzerlandHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/switzerlandHigh.js
// module id = null
// module chunks = 